import { ApiClient } from "./ApiClient";

export interface IApiArray<T> {
	offset: number;
	count: number;
	total: number;
	items: T[];
}

export interface IApiGetQuery {
	filter?: [ string, any[] ];
	offset?: number;
	count?: number;
	sorting?: [ string, "asc" | "desc" ][];
}

export abstract class ApiBase {
	protected client: ApiClient;

	constructor(client: ApiClient) {
		this.client = client;
	}
}



// WEBPACK FOOTER //
// ./src/lib/api/ApiBase.ts